import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-equity-country-info',
  templateUrl: './equity-country-info.component.html',
  styleUrls: ['./equity-country-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, TranslatePipe]
})
export class EquityCountryInfoComponent implements EquityPageComponentModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;

  public infoVisible = false;
}
